import Card from "react-bootstrap/Card";
import { MdLocationOn } from "react-icons/md";
import { BsCalendarDate } from "react-icons/bs";

function ExperienceCard(props) {
  // Split description by periods and filter out empty strings
  const bulletPoints = props.description
    .split('.')
    .map(point => point.trim())
    .filter(point => point.length > 0);

  return (
    <Card className="experience-card-view">
      <Card.Body>
        <Card.Title className="purple">{props.company}</Card.Title>
        <Card.Subtitle className="mb-2 text-white font-weight-bold">
          {props.position}
        </Card.Subtitle>
        <div className="mt-3 mb-3 d-flex align-items-center text-muted">
          <BsCalendarDate className="mr-2" />
          <span className="ml-2">{props.duration}</span>
        </div>
        <div className="mb-3 d-flex align-items-center text-muted">
          <MdLocationOn className="mr-2" />
          <span className="ml-2">{props.location}</span>
        </div>
        <div style={{ textAlign: "justify" }}>
          <ul style={{ paddingLeft: "20px", marginBottom: "0" }}>
            {bulletPoints.map((point, index) => (
              <li key={index} style={{ marginBottom: "8px" }}>
                {point}
              </li>
            ))}
          </ul>
        </div>
      </Card.Body>
    </Card>
  );
}

export default ExperienceCard;
